export class PageName {
    constructor(public PageName: string, public PageDisplayName: string) {
    }
}